import { Box, CircularProgress, Stack, SxProps } from "@mui/material";

export const LoadingTableBlock = ({ sx , type="Assets"}: { sx?: SxProps; type?: string }) => {
    const styles = {
        margin: "0 auto",
        width: "95%",
        maxWidth: "800px",
        height: "100%",
        minHeight: "400px",
    };

    return (
        <Box
            className="table-loading-block"
            sx={{ mt: 5, ...styles, ...sx }}
        >
            <Stack
                className="content"
                justifyContent="center"
                alignItems="center"
                sx={styles}
                spacing={2}
            >
                <CircularProgress />
                <span>Loading {type} Data...</span>
            </Stack>
        </Box>
    );
};

export default LoadingTableBlock;
